import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "astra-bookmark",
  "use": "astra-bookmark-usage",
  "viewBox": "0 0 81.1 81.1",
  "content": "<symbol viewBox=\"0 0 81.1 81.1\" id=\"astra-bookmark\"><path d=\"M43.8 26.3l29.4-13.6-13.5 29.4 13.5 29.4L43.8 58 14.4 71.5l13.5-29.4-13.5-29.4 29.4 13.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/astra-bookmark.svg
// module id = GXne
// module chunks = 1